<template>
    <div class="test-page">
        <top-component></top-component>
        <div class="Context">
            <div class="tableAdress" >
                <div v-if="divtopshow">
                    <img src="../../assets/zjd_img/weizhongjiang.png" alt="">
                    <span class="benci">本次活动您未中任何奖项</span>
                </div>
                <div class="content" v-if="divmidshow">
                    <div class="left" v-if="divmidleftshow">
                        <ul>
                            <li class="li_images">
                                <img class="images" :src="img_url_left" alt="" />
                            </li>
                            <li style="text-align:left;">名称：{{nameleft}}</li>
                            <li style="text-align:left;">来源：{{fromleft}}</li>
                            <li style="text-align:left;">级别：{{levelleft}}</li>
                        </ul>
                    </div>
                    <div class="right" v-if="divmidrightshow">
                        <ul>
                             <li class="li_right">
                                <img  class="rights_images" :src="img_url_right" alt="" />
                            </li>
                            <li style="text-align:left;">名称：{{nameright}}</li>
                            <li style="text-align:left;">来源：{{fromright}}</li>
                            <li style="text-align:left;">级别：{{levelright}}</li>
                        </ul>
                    </div>
                </div>

                <div class="Receiving">
                    <h2>填写收货地址</h2>
                    <el-form>
                        <el-form-item label="收件人" label-width="80px">
                            <el-input v-model="shname"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" label-width="80px">
                            <el-input v-model="mobile"></el-input>
                        </el-form-item>
                        <el-form-item label="所在地区" label-width="80px">
                            <el-input v-model="address"></el-input>
                        </el-form-item>
                        <el-form-item label="详细地址" label-width="80px">
                            <el-input type="textarea" v-model="detailaddress" >
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-button @click="SaveAddress">保存</el-button>
                    <el-dialog title="提示" :visible="errorMsg" width="35%" center>
                        <span class="but">{{title}}</span>
                        <el-button type="primary" @click="errorMsg = false">确 定</el-button>
                    </el-dialog>
                </div>
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
import BottomComponent from "../Components/BottomComponent.vue";
import TopComponent from "../Components/TopComponent.vue";
import { getUserInfo, getUserId } from "@/common/utils/user_info";
import Axios from "@/api/diyaxios";
import Cookies from "js-cookie";
export default {
    nmae: "myPrice",
    data() {
        return {
            divtopshow:false,
            divmidshow:false,
            divmidleftshow:false,
            divmidrightshow:false,
            tableData: [],
            sign_date: "", //中奖时间
            tableData: [],
            shname: "", //收件人
            mobile: "", //手机号码
            address: "", //所在地区
            detailaddress: "", //详细地址
            img_url_left:"",
            nameleft:"",
            fromleft:"",
            levelleft:"",
            img_url_right:"",
            nameright:"",
            fromright:"",
            levelright:"",
            errorMsg: false,
            title: "",
        };
    },

    created() {
        this.queryAddress();
        this.getWinningRecord();
    },
    methods: {
        
     // 保存收货地址
    SaveAddress () {

if (this.shname == '') {
  this.$message({
    message: '请输入收件人',
    type: 'info'
  });
} else if (this.mobile == '') {
  this.$message({
    message: '请输入手机号',   
    type: 'info'
  });
} else if (this.address == '') {
  this.$message({
    message: '请输入所在地区',
    type: 'info'
  });   
}else if (this.detailaddress == '') {
  this.$message({
    message: '请输入详细地址',
    type: 'info'
  });   
}else{
let vm = this;
// const userinfo = getUserInfo();
var obj = {
  userid: getUserId(),
  shname: vm.shname,
  mobile: vm.mobile,
  address: vm.address,
  detailaddress: vm.detailaddress,
};
Axios.post("/gold/activate/saveshdz", {
  params: obj,
}, {
  headers: {
    "Content-Type": "application/json",
  },
}).then((res) => {
  if (res.status) {
    this.$message({
      message: '保存成功',
      type: 'success'
    });
  } else {
    vm.errorMsg = true,
      vm.title = res.errorMsg
  }

}).catch((err) => {
});

}
    },
        // 修改地址信息
        modify() {
            let vm = this;
        },
        // 查询收货地址
        queryAddress() {
            let vm = this;
            var obj = {
                userid: getUserId(),
            };
            Axios.post(
                "/gold/activate/searchshdz",
                {
                    params: obj,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
                .then((res) => {
                    vm.shname = res.data.shname;
                    vm.mobile = res.data.mobile;
                    vm.address = res.data.address;
                    vm.detailaddress = res.data.detailaddress;
                })
                .catch((err) => {});
        },
        //查询中奖纪录
        getWinningRecord() {
            let vm = this;
            if (Cookies.get("token")) {
                Axios.post("/gold/activate/getrecordlist",{
                    params: {
                        selecttj:
                            "gold_activate_detail.level<4 and gold_activate_record.user_id=" +
                            Cookies.get("UserID"),
                        ordertj: "",
                        pageSize:100,
                        pageNum:1,
                    },
                },{
                    headers: {
                        "Content-Type": "application/json",
                        token: Cookies.get("token"),
                    },
                }).then((res) => {
                    if (res.status) {
                        if(res.data.list.length  == 0)
                        {
                              vm.divtopshow = true;
                              vm.divmidshow = false;
                        }
                        else if(res.data.list.length  == 1)
                        {
                            vm.divtopshow = false;
                            vm.divmidshow = true;
                            vm.divmidleftshow = true;
                            vm.divmidrightshow = false;
                            vm.img_url_left =res.data.list[0].img_url;
                            vm.nameleft =res.data.list[0].present_name;
                            vm.fromleft =res.data.list[0].type;
                            vm.levelleft =res.data.list[0].level;
                        }
                        else
                        {
                            vm.divtopshow = false;
                            vm.divmidshow = true;
                            vm.divmidleftshow = true;
                            vm.divmidrightshow = true;

                            vm.img_url_left =res.data.list[0].img_url;
                            vm.nameleft =res.data.list[0].present_name;
                            vm.fromleft =res.data.list[0].type;
                            vm.levelleft =res.data.list[0].level;

                            vm.img_url_right =res.data.list[1].img_url;
                            vm.nameright =res.data.list[1].present_name;
                            vm.fromright =res.data.list[1].type;
                            vm.levelright =res.data.list[1].level;
                        }
                    }
                }).catch((err) => {});
            } else {
                this.$router.push({ name: "Login" });
            }
        },
    },
    components: {
        BottomComponent,
        TopComponent,
    },
};
</script>

<style lang="scss" scoped>
.test-page {
    margin: 0 auto;
    background-color: #e6f3ff;
    .Context {
        width: 1200px;
        margin: 20px auto;
        padding: 30px 30px 150px;
        background-color: #fff;
        .tableAdress {
            text-align: center;
            .content {
                // height: 350px;
                width: 80%;
                margin: 0 auto;
                margin-bottom: 40px;
                display: flex;
                justify-content: space-around;
                flex-direction: row;
                .left {
                    display: flex;
                    justify-content: space-around;
                    ul {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        list-style: none;
                    }
                    li {
                        margin-top: 10px;
                        // box-shadow:rgb(121, 191, 207) 10px 10px 19px ;

                        // margin-bottom: 50px;
                        // img {
                        //     width: 200px;
                        //     height: 200px;
                        // }
                    }
                }
                .right {
                    display: flex;
                    justify-content: space-around;
                    ul {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        list-style: none;
                    }
                    li {
                        margin-top: 10px;
                        // margin-bottom: 50px;
                        // img {
                        //     width: 200px;
                        //     height: 200px;
                        // }
                    }
                }
            }
        }

        .Receiving {
            margin: 10px auto;
            width: 500px;
            // margin-bottom: 60px;
            h2 {
                text-align: center;
            }
            .el-form {
                padding: 30px 0;
                .el-form-item__label {
                    width: 80px;
                    text-align: left;
                    font-size: 15px;
                    font-weight: 600;
                }
                textarea {
                    width: 100%;
                }
            }
            .el-button {
                font-size: 18px;
                background-color: rgb(243, 58, 17);
                color: #ddd;
            }
        }
    }
}
.but {
    display: inline-block;
    padding-bottom: 60px;
    padding-left: 20px;
    line-height: 150px;
    font-size: 16px;
}
::v-deep.el-button--primary {
    background-color: #409EFF !important;
    color: #fff !important;
    text-align: right;
    position: absolute;
    bottom: 30px;
    right: 50px;
}

.li_images{
    width: 250px;
    height: 250px;
    background-color: rgb(243, 227, 227);
    border-radius: 20px !important;
    // box-shadow:rgb(187 235 246) 10px 10px 19px;
    -webkit-box-shadow: #79bfcc 10px 10px 15px;

    .images{
        width: 200px;
        height: 200px;
        margin-top: 10%;
        border-radius: 20px;
    }
}
.li_right{

    width: 250px;
    height: 250px;
    background-color: rgb(221, 219, 219);
    border-radius: 20px !important;
    -webkit-box-shadow: #79bfcc 10px 10px 15px;
    // box-shadow:rgb(187 235 246) 10px 10px 19px;

    .rights_images{
        width: 200px;
        height: 200px;
        margin-top: 10%;
        border-radius: 20px ;
    }
}
.benci{
    width: 500px;
    font-size: 40px;
    // height: 50px;
    // background-color: #000;
    // color: #fff;
    display: block;
    margin: 0 auto;
    text-align: center;
    // line-height: 100px;
    font-weight: 600;

}
::v-deep.el-table .el-table__cell {
    text-align: center;
}
::v-deep.el-table::before {
    background-color: #fff;
}
::v-deep.el-table th.el-table__cell.is-leaf {
    border: none;
}
::v-deep.el-dialog {
    // margin: 0 auto 50px;
    width: 40%;
}


::v-deep.test-page .Context .Receiving {
    width: 100% !important;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/myPrice.vue